import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Protected Route Component
 * 
 * TEMPORARY: Only checks if user is logged in
 * TODO: Replace with admin role check when admin system is implemented
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @param {string} props.redirectTo - Path to redirect to if not authenticated (default: '/')
 */
function ProtectedRoute({ children, redirectTo = '/' }) {
    const { currentUser, loading } = useAuth();

    if (loading) {
        return null;
    }

    // Check if user is logged in
    if (!currentUser) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
}

export default ProtectedRoute;
